import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-factories',
  templateUrl: './factories.component.html',
  styleUrls: ['./factories.component.css']
})
export class FactoriesComponent implements OnInit {
    public itemsListFactories: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadFactories() {
        this.itemsListFactories = await this.datatask.Post(2025);
    }

    private async init() {
        this.loadFactories();
    }

    ngOnInit() {
        this.init();
    }
}
